<mat-card appearance="outlined">
  <video #video class="video-html-cam"></video>

  <div class="container-fluid mt-3">
    <div class="row align-items-center justify-content-center">
      <div class="col col-md-5">
        <app-select *ngIf="cameraList.length > 0" [(ngModel)]="selectedCameraId"
          (ngModelChange)="changeCamera($event)"
          [config]="{ label: 'Selecciona una cámara', options: cameraOptions }">
        </app-select>
      </div>
      <div class="col col-md-5">
        <button mat-stroked-button (click)="closeDialog()" class="col">Salir</button>
      </div>
    </div>
  </div>
</mat-card>


